const getCursorPos = (e) => {
  const currentImg = e.target;
  e = e || window.event;
  const a = currentImg.getBoundingClientRect();
  const x = e.pageX - a.left - window.pageXOffset;
  const y = e.pageY - a.top - window.pageYOffset;
  return {x, y};
}


const Mouse = {
  getCursorPos,
}

export default Mouse;
